import { Platform, StyleSheet } from 'react-native';
import { FontFamily } from '../../../constants/fonts';

const isIOS = Platform.OS === 'ios';

const executiveOverviewCardStyles = StyleSheet.create({
  card: {
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    shadowColor: '#A8B4C5',
    shadowOpacity: 0.08,
    shadowRadius: 6,
    shadowOffset: { width: 0, height: 2 },
    elevation: 2,
    paddingVertical: 20,
    paddingHorizontal: 24,
    flexDirection: 'column',
    rowGap: 4,
    minWidth: 200,
    flex: 1,
    position: 'relative',
    overflow: 'visible',
  },
  cardTitle: {
    fontSize: 12,
    fontFamily: FontFamily.bold,
    fontWeight: '600',
    color: '#616161',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  titleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: 6,
  },
  infoIconWrap: {
    marginTop: -1,
  },
  cardValue: {
    color: '#C12C01',
    fontSize: 36,
    fontFamily: FontFamily.bold,
    fontWeight:'700',
    lineHeight: 40,
  },
  cardSubText: {
    fontSize: 12,
    color: '#838383',
    fontFamily: FontFamily.regular,
  },
  outcomesRow: {
    marginTop: 8,
    flexDirection: 'row',
    columnGap: 8,
  },
  outcomeBox: {
    flex: 1,
    borderRadius: 8,
    padding: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  outcomeValue: {
    fontSize: 19,
    fontFamily: FontFamily.bold,
    marginBottom: 2,
    fontWeight: '700',
  },
  outcomeLabel: {
    fontSize: 10,
    fontFamily: FontFamily.bold,
    fontWeight: '700',
  },
  approvedBox: {
    backgroundColor: '#F3F7FD',
  },
  approvedText: {
    color: '#005CBC',
  },
  pendingBox: {
    backgroundColor: '#E6E6E6',
  },
  pendingText: {
    color: '#616161',
  },
  rejectedBox: {
    backgroundColor: '#FFE5DE',
  },
  rejectedText: {
    color: '#C12C01',
  },
  ptSectionRow: {
    width: '100%',
    flexDirection: 'row',
    flexWrap: 'wrap',
    columnGap: 12,
    rowGap: 12,
    alignItems: 'stretch',
  },
  ptSectionCard: {
    minHeight: isIOS ? 200 : 300,
    flex: 1,
    minWidth: isIOS ? 340 : 420,
    paddingVertical: isIOS ? 16 : 20,
    paddingHorizontal: isIOS ? 20 : 24,
  },
  ptSectionHeaderRow: {
    flexDirection: 'row',
    alignItems: 'baseline',
    marginBottom: isIOS ? 10 : 12,
  },
  ptSectionTitle: {
    fontSize: 16,
    lineHeight: 20,
    color: '#1A1D21',
    fontFamily: FontFamily.bold,
  },
  ptSectionSubTitle: {
    marginLeft: 4,
    fontSize: 12,
    lineHeight: 16,
    color: '#838383',
    fontFamily: FontFamily.regular,
  },
  ptTrendChartContainer: {
    flex: 1,
    minHeight: isIOS ? 188 : 220,
    width: '100%',
    justifyContent: 'space-between',
  },
  ptTrendLegendRow: {
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: 6,
    marginTop: isIOS ? 0 : 2,
    marginLeft: 8,
  },
  ptTrendLegendDot: {
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: '#005CBC',
  },
  ptTrendLegendText: {
    fontSize: 12,
    lineHeight: 16,
    color: '#616161',
    fontFamily: FontFamily.medium,
  },
  ptRegionList: {
    flex: 1,
    justifyContent: 'space-between',
    rowGap: isIOS ? 8 : 10,
  },
  ptRegionRow: {
    rowGap: isIOS ? 2 : 3,
  },
  ptRegionLabel: {
    fontSize: 12,
    color: '#3A3A3A',
    fontFamily: FontFamily.medium,
  },
  ptProgressTrack: {
    width: '100%',
    height: isIOS ? 18 : 22,
    borderRadius: 6,
    overflow: 'hidden',
    backgroundColor: '#E6E6E6',
  },
  ptProgressFill: {
    height: '100%',
    backgroundColor: '#C12C01',
    justifyContent: 'center',
    alignItems: 'flex-end',
    paddingRight: isIOS ? 6 : 8,
    minWidth: isIOS ? 34 : 40,
  },
  ptProgressText: {
    color: '#FFFFFF',
    fontSize: 11,
    fontFamily: FontFamily.bold,
    lineHeight: 14,
  },
  cardTitleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: 6,
  },
  infoIconContainer: {
    padding: 4,
    justifyContent: 'center',
    alignItems: 'center',
  },
  /** Info icon positioned to top-right corner of card — isolated for hover tooltip */
  infoIconTopRight: {
    position: 'absolute',
    top: 12,
    right: 12,
    padding: 4,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 5,
  },
  tooltipBox: {
    position: 'absolute',
    top: 36,
    right: 12,
    left: 24,
    backgroundColor: '#F5F5F5',
    borderRadius: 4,
    padding: 8,
    borderLeftWidth: 3,
    borderLeftColor: '#005CBC',
    zIndex: 10,
    maxWidth: '100%',
  },
  tooltipText: {
    fontSize: 11,
    color: '#424242',
    fontFamily: FontFamily.regular,
    lineHeight: 16,
  },
  contentWrapper: {
    flexDirection: 'column',
    rowGap: 4,
  },
});

export default executiveOverviewCardStyles;
